export const normalizeAbleToWithdraw = (isAble: any): boolean => isAble.IsValidTime;
